import { NavLink } from "react-router-dom";
import MarriageAndParentingLogo from '../assets/marriageandparenting (2).svg';


const linkClass = ({ isActive }: { isActive: boolean }) =>
  `text-[13px] px-2.5 py-1.5 rounded-md transition-colors no-underline ${isActive ? "bg-primary-light text-primary" : "text-[#666] hover:bg-primary-light hover:text-primary"
  }`;

export default function Nav() {
  return (
    <nav className="flex items-center justify-between px-7 py-4 bg-white border border-border rounded-2xl">
      <NavLink to="/" className="flex items-center gap-3 no-underline">
        <div className="w-13 h-13">
          <img src={MarriageAndParentingLogo} />
        </div>
        <div className="flex flex-col gap-1">
          <div className="font-display text-[22px] font-semibold text-primary-dark leading-tight tracking-[0.06em]">MA &amp; PA Program</div>
          <div className="text-[11px] text-[#999] tracking-[0.14em] uppercase">MArriage &amp; PArenting</div>
        </div>
      </NavLink>

      <div className="flex gap-1">
        <NavLink to="/" end className={linkClass}>Home</NavLink>
        <NavLink to="/about" className={linkClass}>About</NavLink>
        <NavLink to="/news" className={linkClass}>News</NavLink>
        <NavLink to="/consultants" className={linkClass}>Consultants</NavLink>
      </div>

      <div className="flex gap-2">
        <NavLink
          to="/contact"
          className="text-primary text-[13px] font-medium px-4 py-2 rounded-[20px] border border-primary transition-colors hover:bg-primary-light no-underline"
        >
          Contact
        </NavLink>
        <NavLink
          to="/order-form"
          className="bg-primary text-white text-[13px] font-medium px-4 py-2 rounded-[20px] transition-colors hover:bg-primary-mid no-underline"
        >
          Order Now
        </NavLink>
      </div>
    </nav>
  );
}
